import { ProcessData } from '@mirage-projects/cw-models';

import { Process } from './Process';
import { Step } from './Step';

export class Loader {
    /**
     * Loads the processes with the steps
     * @param data The process data to instance
     *
     */
    static loadProcess(data: ProcessData): Process | undefined {
        if (!data?.steps) {
            return;
        }
        const stepList = data.steps.map((obj) => new Step(obj));

        return new Process(data.name, ...stepList);
    }
}
